import { FormDimensions } from './types'

export const BATCH_ARCHIVED_UNARCHIVED = [
  {
    id: 'true',
    name: 'Archived Batches',
  },
  {
    id: 'false',
    name: 'Unarchived Batches',
  },
]
export const BATCH_CLOSED_UNCLOSED = [
  {
    id: 'true',
    name: 'Completed Batches',
  },
  {
    id: 'false',
    name: 'Incomplete Batches',
  },
]

export const FORM_DIMENSIONS: FormDimensions = {
  ROW_GUTTER: [24, 16],
  COL_SPAN: 12,
}

/**
 * Keeps the batch modal inside the viewport: the body scrolls rather than the
 * dialog growing past the screen and taking its footer with it.
 */
export const BATCH_MODAL = {
  MAX_WIDTH: 'calc(100vw - 32px)',
  // Only the modal's own chrome is reserved, so short forms never scroll.
  BODY_MAX_HEIGHT: 'calc(100vh - 180px)',
}

export const ACTIONS = [
  {
    id: 'ARCHIVE',
    name: 'Archive Batch',
  },
  {
    id: 'EDIT',
    name: 'Edit Batch',
  },
  {
    id: 'CLOSE',
    name: 'Mark As Completed',
  }
]

export const PACK_SEARCH_DEBOUNCE_MS = 300

/** Debounce for search-as-you-type user (mentor/coordinator) lookups. */
export const USER_SEARCH_DEBOUNCE_MS = 300

/** The first page of any paginated list — used when a search resets to the top. */
export const FIRST_PAGE = 1

export const TOKEN_SEPARATORS = [' ', ',']

export const TEL_REGEX = /^\+?\d{1,3}[- ]?\d{3,}$/

export enum ADD_STUDENTS_WARNING_NOTES {
  NEED_ENTRI_APP_ACCOUNT = 'The phone number should be associated with an Entri App account.',
  NUMBERS_SHOULD_HAVE_COUNTRY_CODE = 'Phone numbers should commence with the country code (e.g., +91, +1, ...).',
  HOW_TO_ADD_MULTIPLE_PHONE_NUMBERS = 'You can add multiple phone numbers by separating them with a comma ( , ) or a space ( _ ) after each phone number.',
}

export enum PERMISSION_HELPER_TEXT {
  NO_EDIT = 'You do not have the necessary permissions to edit this item.'
}

/** A batch can hold at most this many live class faculties, matching the API's limit. */
export const MAX_FACULTIES = 6

/** Participant-type labels shared by the DM and group member tables. */
export const PARTICIPANT_TYPE_LABELS: Record<string, string> = {
  mentor: 'Mentor',
  batch_owner: 'Batch Owner',
  tutor: 'Tutor',
  support: 'Support',
  user: 'Student',
  faculty: 'Faculty',
}

/**
 * Drawer Type labels. A batch 'dm' is a faculty DM by UI convention only — the
 * chat service has no such type, and nothing else in a batch creates one.
 */
export const CONVERSATION_TYPE_LABELS: Record<string, string> = {
  dm: 'Faculty DM',
  managed_dm: 'Managed DM',
  group: 'Group',
  channel: 'Channel',
}

export const ROLE_LABELS: Record<string, string> = {
  owner: 'Owner',
  admin: 'Admin',
  member: 'Member',
}

/**
 * Shown on hover: a faculty holds 'admin' in a faculty DM, which reads
 * alarmingly without saying it only covers pinning and resolving queries.
 */
export const ROLE_CAPABILITIES: Record<string, string> = {
  owner: 'Full control of the conversation',
  admin: 'Can pin messages and resolve queries',
  member: 'Can send and read messages',
}

/**
 * Hints for the DM-creating fields. Kept terse because the modal is long; the
 * faculty one renders only while enableManagedDm is on.
 */
export const DM_HINTS = {
  faculties: `Each gets a DM with every batch member. Up to ${MAX_FACULTIES} faculties.`,
  facultyDms:
    'Enable to allow individual student DMs, otherwise only group chat will be available.',
  enableManagedDm:
    'Creates Managed and Faculty DMs for all members. Off stops new ones; existing stay open.',
}

/**
 * Empty state for the Faculty DMs tab, which has no create button — otherwise
 * an empty tab is indistinguishable from a failed sync.
 */
export const FACULTY_DMS_EMPTY_TEXT =
  'Faculty DMs are created automatically when faculty are mapped and DM Auto Add/Remove is on.'

export const MENTOR_ROLES = [
  'freelance-gold-mentor',
  'gold-mentor-lead',
  'asst.-gold-mentor',
  'freelance-asst.-gold-mentor',
  'gold-mentor',
  'elevate-mentor',
  'placement-team-member',
]

export const COURSE_VERTICALS = [
  {
    value: 'TESTPREP',
    label: 'Testprep',
  },
  {
    value: 'SKILLING',
    label: 'Skilling',
  },
  {
    value: 'ELEVATE',
    label: 'Elevate',
  },
]
